module.exports = __webpack_public_path__ + "static/mr-concert-performance-04-e6cb673be0ba9e48b27a3905e1d97916.jpg";